import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, Checkbox, FormControlLabel, Button } from "@mui/material";
import { TextField, Autocomplete } from "@totalsoft/rocket-ui";
import { DateTime } from "@ts-private/rocket-extensions";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { isValid, getErrors } from "@totalsoft/pure-validations-react";

export const PJPartnerComponent = ({
  partner,
  legalForms,
  onSave,
  onPropertyChange,
  onPartnerPropertyChange,
  saveDisabled,
  hasWritePermission,
  validationPartner
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          required
          fullWidth
          id="pjPartner_uniqueId"
          value={partner.uniqueId || ""}
          name="uniqueId"
          label={t("Partner.CompanyUniqueID")}
          error={!isValid(validationPartner.uniqueId)}
          helperText={getErrors(validationPartner.uniqueId)}
          onChange={onPartnerPropertyChange("uniqueId")}
          disabled={!hasWritePermission}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          required
          fullWidth
          id="pjPartner_partnerName"
          value={partner.partnerName || ""}
          name="partnerName"
          label={t("Partner.CompanyName")}
          error={!isValid(validationPartner.partnerName)}
          helperText={getErrors(validationPartner.partnerName)}
          onChange={onPartnerPropertyChange("partnerName")}
          disabled={!hasWritePermission}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <DateTime
          fullWidth
          id="pjPartner_registrationDate"
          value={partner.company?.registrationDate}
          label={t("Partner.RegistrationDate")}
          onChange={onPropertyChange("registrationDate")}
          disabled={!hasWritePermission}
          timeFormat={false}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <TextField
          fullWidth
          id="pjPartner_commercialRegistration"
          value={partner.company ? partner.company.commercialRegistration || "" : ""}
          name="commercialRegistration"
          label={t("Partner.CommercialRegistration")}
          onChange={onPropertyChange("commercialRegistration")}
          disabled={!hasWritePermission}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Autocomplete
          fullWidth
          id="pjPartner_legalForm"
          label={t("Partner.LegalForm")}
          value={partner.company ? partner.company.legalFormId || "" : ""}
          valueKey="legalFormId"
          labelKey="legalFormName"
          simpleValue={true}
          onChange={onPropertyChange("legalFormId")}
          disabled={!hasWritePermission}
          options={legalForms}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <FormControlLabel
          label={t("Partner.External")}
          control={
            <Checkbox
              id="pjPartner_isExternal"
              checked={Boolean(partner.isExternal)}
              onChange={onCheckBoxChange(onPartnerPropertyChange("isExternal"))}
              disabled={!hasWritePermission}
              color="primary"
              name="external"
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          id={"pjPartner_remarks"}
          label={t("Partner.Remarks")}
          value={partner.remark || ""}
          onChange={onPartnerPropertyChange("remark")}
          disabled={!hasWritePermission}
          multiline
          inputProps={{ maxLength: 255 }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Button
          id="pjPartner_saveBtn"
          color="primary"
          variant="contained"
          onClick={onSave}
          disabled={saveDisabled || !hasWritePermission || !(validationPartner |> isValid)}
        >
          {t("Save")}
        </Button>
      </Grid>
    </>
  );
};
PJPartnerComponent.propTypes = {
  partner: PropTypes.object.isRequired,
  legalForms: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onPartnerPropertyChange: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  validationPartner: PropTypes.object.isRequired,
  hasWritePermission: PropTypes.bool.isRequired
};

export default PJPartnerComponent;
